import axios from 'axios'
import Cookies from 'js-cookie'

import ProductItem from '@/js/components/product-item.js'
import { getRecommendedProducts } from '@/js/utils/helpers'

import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'
import { productQuery, transformGraphqlProduct } from '@/js/utils/data'

export default {
  components: {
    ProductItem
  },

  props: {
    productId: {
      type: String,
      required: true
    },
    collectionHandle: {
      type: String,
      required: true
    },
    usingRecommendationsApi: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      recommendedProducts: [],
      filteredProducts: [],
      products: []
    }
  },

  computed: {
    currentState () {
      return Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
    }
  },

  async created () {
    // Recommended products
    this.recommendedProducts = await getRecommendedProducts(this.productId).catch(error => {
      console.log(error)
    })

    this.filteredProducts = await this._getMostPopularProducts()

    if (this.recommendedProducts.length > 4) {
      this.recommendedProducts = this.recommendedProducts.slice(0, 4)
    }

    this.products = this.usingRecommendationsApi ? this.recommendedProducts : this.filteredProducts

    this.isLoading = false
  },

  methods: {
    async _getMostPopularProducts () {
      const data = `{
        collection(handle: "${this.collectionHandle}") {
          products (first: 100, sortKey: BEST_SELLING) {
            edges {
              node {
                ${productQuery}
              }
            }
          }
        }
      }`

      return await axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        const products = data.data.collection.products.edges
        const filteredProducts = []
        products.forEach((product) => {
          let productItem = {}
          productItem = transformGraphqlProduct(product.node)

          // check if the current state value is ACT
          if (this.currentState === 'ACT') {
            // If the state is ACT, include products from both ACT and NSW warehouses
            if ((productItem.available_on?.includes(this.currentState) || productItem.available_on?.includes('NSW')) && filteredProducts?.length < 4) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          } else {
            // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
            if (productItem.available_on?.includes(this.currentState) && filteredProducts?.length < 4) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          }
        })
        return filteredProducts
      }).catch((error) => {
        console.log('Get products from most popular collection error:', error)
        throw error
      })
    }
  }
}
